/**
 * Owner: Masa Bayu
 * File: LandingIcons.tsx
 * Date:Time: 2026-10-18 11:45
 * Description: Ikon garis home landing §376 — set SVG inline sebahasa mockup
 *   (stroke 2px, bulat). Tiada pustaka ikon luar. §394: dinaik taraf menjadi
 *   standard ikon semua halaman qxread (+9 ikon: receipt, chart, card, devices,
 *   bag, checkCircle, share, medal, headset); emoji fungsi digugurkan.
 *   §461: +1 ikon 'upload' (cermin download) untuk tab Penerbitan bar bawah
 *   bersama — SVG inline .qxpm__bottom dibuang.
 */

import type { ReactElement } from 'react';

export type LandingIconName =
  | 'search'
  | 'filter'
  | 'bell'
  | 'heart'
  | 'cart'
  | 'user'
  | 'home'
  | 'bookOpen'
  | 'book'
  | 'bookmark'
  | 'star'
  | 'flame'
  | 'grid'
  | 'cap'
  | 'doc'
  | 'rocket'
  | 'leaf'
  | 'briefcase'
  | 'gear'
  | 'sun'
  | 'sparkle'
  | 'more'
  | 'arrowRight'
  | 'chevronRight'
  | 'chevronLeft'
  | 'plus'
  | 'bolt'
  | 'shield'
  | 'globe'
  | 'download'
  | 'upload'
  | 'close'
  | 'pen'
  | 'check'
  | 'clock'
  | 'lock'
  | 'receipt'
  | 'chart'
  | 'card'
  | 'devices'
  | 'bag'
  | 'checkCircle'
  | 'share'
  | 'medal'
  | 'headset'
  | 'message'
  | 'users'
  | 'pin';

const PATHS: Record<LandingIconName, ReactElement> = {
  search: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
    </>
  ),
  filter: (
    <>
      <path d="M4 6h10" />
      <path d="M18 6h2" />
      <path d="M4 12h4" />
      <path d="M12 12h8" />
      <path d="M4 18h12" />
      <path d="M20 18h0" />
      <circle cx="16" cy="6" r="2" />
      <circle cx="10" cy="12" r="2" />
      <circle cx="18" cy="18" r="2" />
    </>
  ),
  bell: (
    <>
      <path d="M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6" />
      <path d="M10 19a2 2 0 0 0 4 0" />
    </>
  ),
  heart: (
    <path d="M12 20s-7-4.5-9.5-9A5.5 5.5 0 0 1 12 6a5.5 5.5 0 0 1 9.5 5C19 15.5 12 20 12 20Z" />
  ),
  cart: (
    <>
      <circle cx="9" cy="20" r="1.6" />
      <circle cx="17" cy="20" r="1.6" />
      <path d="M3 4h2l2.4 11h10.2L21 8H6" />
    </>
  ),
  user: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21c1.5-4 5-6 8-6s6.5 2 8 6" />
    </>
  ),
  home: (
    <>
      <path d="m3 11 9-8 9 8" />
      <path d="M5 10v10h14V10" />
    </>
  ),
  bookOpen: (
    <>
      <path d="M12 5v14" />
      <path d="M4 5h6a2 2 0 0 1 2 2 2 2 0 0 1 2-2h6v11h-6a2 2 0 0 0-2 2 2 2 0 0 0-2-2H4Z" />
    </>
  ),
  book: (
    <>
      <path d="M4 5a2 2 0 0 1 2-2h13v18H6a2 2 0 0 0-2 2Z" />
      <path d="M4 19V5" />
    </>
  ),
  bookmark: <path d="M7 3h10a1 1 0 0 1 1 1v17l-6-4-6 4V4a1 1 0 0 1 1-1Z" />,
  star: <path d="m12 3 2.7 5.6 6.1.8-4.5 4.3 1.1 6.1-5.4-2.9-5.4 2.9 1.1-6.1L3.2 9.4l6.1-.8Z" />,
  flame: (
    <path d="M12 3c1 3-2 4-2 7a2.5 2.5 0 0 0 5 .5c1.5 1.5 2.5 3 2.5 5a5.5 5.5 0 1 1-11 0C6.5 11 11 9 12 3Z" />
  ),
  grid: (
    <>
      <rect x="4" y="4" width="7" height="7" rx="1.5" />
      <rect x="13" y="4" width="7" height="7" rx="1.5" />
      <rect x="4" y="13" width="7" height="7" rx="1.5" />
      <rect x="13" y="13" width="7" height="7" rx="1.5" />
    </>
  ),
  cap: (
    <>
      <path d="m2 9 10-5 10 5-10 5Z" />
      <path d="M6 11v5c0 1.5 3 3 6 3s6-1.5 6-3v-5" />
    </>
  ),
  doc: (
    <>
      <path d="M6 2h9l4 4v16H6Z" />
      <path d="M15 2v4h4" />
      <path d="M9 12h7M9 16h7" />
    </>
  ),
  rocket: (
    <>
      <path d="M12 15c-2 0-3-1-3-3 1-5 4-8 9-9-1 5-4 8-9 9Z" />
      <path d="M9 12l-3 1 2 2M12 15l-1 3 2-2" />
      <path d="M5 19c-1.5 1-2 3-2 3s2-.5 3-2" />
    </>
  ),
  leaf: (
    <>
      <path d="M4 20C2 12 8 4 20 4c0 12-8 16-14 15" />
      <path d="M4 20c2-6 6-10 11-12" />
    </>
  ),
  briefcase: (
    <>
      <rect x="3" y="7" width="18" height="13" rx="2" />
      <path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
      <path d="M3 13h18" />
    </>
  ),
  gear: (
    <>
      <circle cx="12" cy="12" r="3.2" />
      <path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5 5l2.1 2.1M16.9 16.9 19 19M19 5l-2.1 2.1M7.1 16.9 5 19" />
    </>
  ),
  sun: (
    <>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.5 4.5 6.6 6.6M17.4 17.4l2.1 2.1M19.5 4.5 17.4 6.6M6.6 17.4 4.5 19.5" />
    </>
  ),
  sparkle: (
    <>
      <path d="M12 3l1.8 4.7L18.5 9l-4.7 1.8L12 15.5l-1.8-4.7L5.5 9l4.7-1.3Z" />
      <path d="M18 14l.9 2.3 2.3.9-2.3.9-.9 2.3-.9-2.3-2.3-.9 2.3-.9Z" />
    </>
  ),
  more: (
    <>
      <circle cx="5" cy="12" r="1.4" />
      <circle cx="12" cy="12" r="1.4" />
      <circle cx="19" cy="12" r="1.4" />
    </>
  ),
  arrowRight: (
    <>
      <path d="M4 12h15" />
      <path d="m13 6 6 6-6 6" />
    </>
  ),
  chevronRight: <path d="m9 5 7 7-7 7" />,
  chevronLeft: <path d="m15 5-7 7 7 7" />,
  plus: (
    <>
      <path d="M12 5v14" />
      <path d="M5 12h14" />
    </>
  ),
  bolt: <path d="M13 2 4 14h6l-1 8 9-12h-6Z" />,
  shield: (
    <>
      <path d="M12 2 4 5.5V11c0 6 3.5 9.5 8 11 4.5-1.5 8-5 8-11V5.5Z" />
      <path d="m8.5 11.5 2.5 2.5 4.5-4.5" />
    </>
  ),
  globe: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18" />
      <path d="M12 3c3 3.5 3 14 0 18-3-4-3-14.5 0-18Z" />
    </>
  ),
  download: (
    <>
      <path d="M12 3v12" />
      <path d="m7 11 5 5 5-5" />
      <path d="M5 21h14" />
    </>
  ),
  upload: (
    <>
      <path d="M12 15V3" />
      <path d="m7 7 5-5 5 5" />
      <path d="M5 21h14" />
    </>
  ),
  close: (
    <>
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </>
  ),
  pen: (
    <>
      <path d="M4 20l1-4L16.5 4.5a2.1 2.1 0 0 1 3 3L8 19Z" />
      <path d="m14.5 6.5 3 3" />
    </>
  ),
  check: <path d="m5 12 5 5 9-10" />,
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3.5 2" />
    </>
  ),
  lock: (
    <>
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </>
  ),
  receipt: (
    <>
      <path d="M6 2.5h12v19l-2-1.4-2 1.4-2-1.4-2 1.4-2-1.4-2 1.4Z" />
      <path d="M9 8h6M9 12h6M9 16h4" />
    </>
  ),
  chart: (
    <>
      <path d="M4 20h16" />
      <rect x="6" y="11" width="3" height="7" rx="1" />
      <rect x="11" y="7" width="3" height="11" rx="1" />
      <rect x="16" y="13" width="3" height="5" rx="1" />
    </>
  ),
  card: (
    <>
      <rect x="3" y="6" width="18" height="13" rx="2" />
      <path d="M3 10.5h18" />
      <path d="M7 15h4" />
    </>
  ),
  devices: (
    <>
      <rect x="2.5" y="5" width="13" height="10" rx="1.5" />
      <path d="M6 19h6M9 15v4" />
      <rect x="17" y="9" width="4.5" height="9" rx="1" />
    </>
  ),
  bag: (
    <>
      <path d="M5.5 8h13l1 12.5h-15Z" />
      <path d="M9 8V6.5a3 3 0 0 1 6 0V8" />
    </>
  ),
  checkCircle: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="m8.5 12 2.3 2.3 4.7-4.6" />
    </>
  ),
  share: (
    <>
      <circle cx="6" cy="12" r="2.4" />
      <circle cx="18" cy="6" r="2.4" />
      <circle cx="18" cy="18" r="2.4" />
      <path d="m8.2 10.9 7.6-3.8M8.2 13.1l7.6 3.8" />
    </>
  ),
  medal: (
    <>
      <circle cx="12" cy="9" r="5" />
      <path d="m8.6 13.4-3.6 7.1 5.2-2.6M15.4 13.4l3.6 7.1-5.2-2.6" />
    </>
  ),
  headset: (
    <>
      <path d="M4 14v-2a8 8 0 0 1 16 0v2" />
      <rect x="2.5" y="14" width="4" height="6" rx="1.5" />
      <rect x="17.5" y="14" width="4" height="6" rx="1.5" />
      <path d="M20 20v.5a3 3 0 0 1-3 3h-3" />
    </>
  ),
  message: (
    <>
      <path d="M4 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H9l-5 4V5Z" />
      <path d="M8.5 10h7M8.5 13h4" />
    </>
  ),
  users: (
    <>
      <circle cx="9" cy="8" r="3.4" />
      <path d="M3 20c1.2-3.4 3.4-5 6-5s4.8 1.6 6 5" />
      <circle cx="17.5" cy="9" r="2.6" />
      <path d="M16.5 15.2c2.4.3 4 1.8 4.9 4.3" />
    </>
  ),
  pin: (
    <>
      <path d="M12 21s-6-5.2-6-10a6 6 0 1 1 12 0c0 4.8-6 10-6 10Z" />
      <circle cx="12" cy="11" r="2.4" />
    </>
  ),
};

const FILLED: Partial<Record<LandingIconName, boolean>> = { star: true };

export function LandingIcon({
  name,
  size = 20,
  className,
}: {
  readonly name: LandingIconName;
  readonly size?: number;
  readonly className?: string;
}): ReactElement {
  const filled = FILLED[name] === true;
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={filled ? 0 : 2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
    >
      {PATHS[name]}
    </svg>
  );
}
